import fetcher from 'features/shared/utils/fetcher'
import { DailyEvolutionPost, DailyEvolutionModel } from '../types/dailyEvolution'

export async function createDailyEvolution(data: DailyEvolutionPost) {
  return await fetcher.post('/daily-evolution/create', data)
}

export async function getDailyEvolution(serviceId: string) {
  return await fetcher.get<{data: DailyEvolutionModel}>(`/daily-evolution/${serviceId}`)
}